import axios from "@common/api/desktop/axios";

class Count {
  getCounts = async (operatorId, siteId, fromId, toId) => {
    const response = await axios.get(
      `collections/count/week/${operatorId},${siteId},${fromId},${toId}`,
    );
    return response.data;
  };

  getBatch = async (collectionType, batchId) => {
    const response = await axios.get(
      `collections/count/batch/${collectionType},${batchId}`,
    );
    return response.data;
  };

  getCountsExport = async (operatorId, siteId, fromId, toId) => {
    const response = await axios.get(
      `collections/count/week/export/${operatorId},${siteId},${fromId},${toId}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getBatchExport = async (batchId, collectionType) => {
    const response = await axios.get(
      `collections/count/batch/export/${batchId},${collectionType}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getReportPdf = async (batchId, collectionType) => {
    const response = await axios.get(
      `Report/Collection/Interim/Summary/PDF/${batchId},${collectionType}`,
      { responseType: "arraybuffer" },
    );
    return response;
  };

  addComment = async (CollectionType, CollectionId, Comment) => {
    const data = {
      CollectionType,
      CollectionId,
      Comment,
    };

    const response = await axios.put(`collections/comments/add2/`, data);
    return response.data;
  };

  getComments = async (collectionType, collectionId) => {
    const response = await axios.get(
      `collections/comments/byCollection2/${collectionType},${collectionId}`,
    );
    return response.data;
  };
}

const count = new Count();

export default count;
